import { memo, useEffect, useRef } from 'react';
import classnames from 'classnames';
import gsap from 'gsap';

import styles from './ProgressNavigationArrow.module.scss';

import BaseButton from '@/components/BaseButton/BaseButton';

import LeftArrow from '@/components/svgs/LeftArrow.svg';
import RightArrow from '@/components/svgs/RightArrow.svg';
import { NavigationArrow } from '@/data/data';

export type Props = {
  className?: string;
  percentage: number;
  onLeftClick?: Function;
  onRightClick?: Function;
};

function ProgressNavigationArrow({ className, onLeftClick, onRightClick, percentage }: Props) {
  const circleRef = useRef<SVGCircleElement | null>(null);

  useEffect(() => {
    gsap.to(circleRef.current, { duration: 0.7, drawSVG: `${percentage}%`, ease: 'ease02' });
  }, [percentage]);

  return (
    <div className={classnames(styles.ProgressNavigationArrow, className)}>
      <BaseButton onClick={onLeftClick} className={styles.leftButton} aria-label={NavigationArrow.PREV}>
        <LeftArrow className={styles.leftArrow} aria-hidden />
      </BaseButton>
      <BaseButton onClick={onRightClick} className={styles.rightButton} aria-label={NavigationArrow.NEXT}>
        <svg viewBox="0 0 40 40" width={40} className={styles.circle}>
          <circle ref={circleRef} r="19.5" transform="matrix(-1 0 0 1 20 20)" stroke="black" strokeWidth={2.8} />
        </svg>
        <RightArrow className={styles.rightArrow} aria-hidden />
      </BaseButton>
    </div>
  );
}

export default memo(ProgressNavigationArrow);
